<template>
  <div
    class="complaint_modal modal download_app_modal"
    v-if="$store.state.main.download_modal"
  >
    <div class="phone_modal__overlay bg-overlay" @click="close_modal"></div>
    <div
      class="complaint_modal__inner bg-white"
      :class="{ mob_100: windowWidth <= 767 }"
    >
      <div class="complaint_modal__ttl_wrapper flex j_sb a_center">
        <span class="f-24 bold uppercase f-light-purple">{{
          $fn.tr("აპლიკაციის გადმოწერა")
        }}</span>

        <div class="complaint_modal__x_btn pointer" @click="close_modal()">
          <svg
            id="Group_4238"
            data-name="Group 4238"
            xmlns="http://www.w3.org/2000/svg"
            width="16.971"
            height="16.971"
            viewBox="0 0 16.971 16.971"
          >
            <rect
              id="Rectangle_543"
              data-name="Rectangle 543"
              width="20"
              height="4"
              rx="2"
              transform="translate(2.828 0) rotate(45)"
            />
            <rect
              id="Rectangle_1219"
              data-name="Rectangle 1219"
              width="20"
              height="4"
              rx="2"
              transform="translate(16.971 2.829) rotate(135)"
            />
          </svg>
        </div>
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="complaint_modal__form"
        v-show="!success_sent"
      >
        <el-form-item prop="phone">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--phone"
            :class="{ selected: ruleForm.phone.length !== 0 }"
            >{{ $fn.tr("ტელეფონის ნომერი") }}</span
          >

          <el-input
            v-model.number="ruleForm.phone"
            @focus="add_focus('phone')"
            @blur="remove_focus('phone', ruleForm.phone)"
          ></el-input>
        </el-form-item>

        <vue-recaptcha
          ref="recaptcha"
          :sitekey="$store.state.main.indx.siteSettings.google_recaptcha_key"
          :loadRecaptchaScript="true"
          class="g-recaptcha"
          size="compact"
          @verify="recaptcha_success()"
          @error="recaptcha_fail()"
        ></vue-recaptcha>

        <div class="complaint_modal__terms flex">
          <p class="regular">
            {{
              _.get(
                $store.state.main.indx.widgets,
                "terms_and_conditions.terms.teaser"
              )
            }}
            <a
              target="_blank"
              :href="
                _.get(
                  $store.state.main.indx.widgets,
                  'terms_and_conditions.terms.url'
                )
              "
              class="f-cyan underline"
              >{{
                _.get(
                  $store.state.main.indx.widgets,
                  "terms_and_conditions.terms.title"
                )
              }}</a
            >
          </p>
        </div>

        <el-form-item>
          <el-button
            class="button complaint_modal_validate_button"
            @click="submitForm('ruleForm')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("გაგზავნა")
            }}</span>
          </el-button>
        </el-form-item>

        <div class="download_app_modal__see_more flex column">
          <span class="f-gray medium">{{
            _.get($store.state.main.indx.widgets, "app_stores.teaser")
          }}</span>
          <div class="flex j_sb">
            <a
              target="_blank"
              :href="
                _.get($store.state.main.indx.widgets, 'app_stores.button_1.url')
              "
              v-html="
                _.get($store.state.main.indx.widgets, 'app_stores.button_1.svg')
              "
            ></a>
            <a
              target="_blank"
              :href="
                _.get($store.state.main.indx.widgets, 'app_stores.button_1.url')
              "
              v-html="
                _.get($store.state.main.indx.widgets, 'app_stores.button_2.svg')
              "
            ></a>
          </div>
        </div>
      </el-form>

      <div class="complaint_modal__success flex column" v-show="success_sent">
        <span class="f-18 bold mb-10"  :style="{color: '#575757'}">{{ $fn.tr("მადლობა!") }}</span>
        <span class="f-16 medium f-gray">{{
          $fn.tr(
            "აპლიკაციის ბმული გამოგეგზავნათ თქვენს მიერ მითითებულ მობილურის ნომერზე. აპლიკაციის გასააქტიურებლად გთხოვთ იხილოთ ინსტრუქცია."
          )
        }}</span>
          <div class="download_app_modal__see_more flex column">
          <span class="f-gray medium">{{
            _.get($store.state.main.indx.widgets, "app_stores.teaser")
          }}</span>
          <div class="flex j_sb">
            <a
              target="_blank"
              :href="
                _.get($store.state.main.indx.widgets, 'app_stores.button_1.url')
              "
              v-html="
                _.get($store.state.main.indx.widgets, 'app_stores.button_1.svg')
              "
            ></a>
            <a
              target="_blank"
              :href="
                _.get($store.state.main.indx.widgets, 'app_stores.button_1.url')
              "
              v-html="
                _.get($store.state.main.indx.widgets, 'app_stores.button_2.svg')
              "
            ></a>
          </div>
        </div>
        <div
          class="complaint_modal__success--button button flex a_center j_center f-white bold uppercase pointer"
          @click="back_to_complaint()"
        >
          <span class="bold">{{ $fn.tr("დახურვა") }}</span>
          <svg
            id="Group_5393"
            data-name="Group 5393"
            xmlns="http://www.w3.org/2000/svg"
            width="12.9"
            height="12.901"
            viewBox="0 0 12.9 12.901"
          >
            <rect
              id="Rectangle_543"
              data-name="Rectangle 543"
              width="15.203"
              height="3.041"
              rx="1.52"
              transform="translate(2.15 0) rotate(45)"
              fill="#fff"
            />
            <rect
              id="Rectangle_1219"
              data-name="Rectangle 1219"
              width="15.203"
              height="3.041"
              rx="1.52"
              transform="translate(12.9 2.15) rotate(135)"
              fill="#fff"
            />
          </svg>
        </div>

 

      </div>
      <div class="download_app_modal__footer" > 
      <svg xmlns="http://www.w3.org/2000/svg" width="104.418" height="65.05" viewBox="0 0 104.418 65.05">
  <g id="Group_3318" data-name="Group 3318" transform="translate(-593.754 -216.265)">
    <path id="Path_1370" data-name="Path 1370" d="M643.151,240.638A4.58,4.58,0,0,1,641.7,244.4a51.82,51.82,0,0,1-15.964,10.16,7.027,7.027,0,0,1-1.672.446,1.277,1.277,0,0,1-1.545-1.325,3.208,3.208,0,0,1,.166-.789c1.563-4.455,6.888-14.142,9.155-18.13,2.84-5,10.291-17.024,11.416-18.345a.4.4,0,0,1,.487-.118c.185.091.331.208.15.871-.977,3.567-2.39,11.329-.931,21.937.079.552.152,1.05.191,1.526" fill="#7063ea"/>
    <path id="Path_1371" data-name="Path 1371" d="M644.949,245.731a4.584,4.584,0,0,1,3.988-.626,51.811,51.811,0,0,1,16.781,8.746,7,7,0,0,1,1.222,1.225,1.278,1.278,0,0,1-.375,2,3.243,3.243,0,0,1-.766.249c-4.64.875-15.691,1.106-20.279,1.137-5.748.041-19.886-.4-21.593-.712a.4.4,0,0,1-.348-.363c-.013-.208.016-.392.681-.566,3.578-.938,11.006-3.595,19.462-10.161.439-.347.834-.659,1.227-.93" fill="#7063ea"/>
    <path id="Path_1372" data-name="Path 1372" d="M648.46,241.628a4.585,4.585,0,0,1-2.536-3.142,51.819,51.819,0,0,1-.816-18.9,7.01,7.01,0,0,1,.45-1.671,1.277,1.277,0,0,1,1.92-.675,3.1,3.1,0,0,1,.6.539c3.077,3.58,8.8,13.036,11.125,16.992,2.909,4.959,9.6,17.424,10.178,19.058a.4.4,0,0,1-.14.481c-.172.116-.347.184-.83-.3-2.6-2.63-8.617-7.735-18.532-11.775-.52-.207-.986-.394-1.418-.6" fill="#7063ea"/>
    <path id="Path_1373" data-name="Path 1373" d="M598.852,272.718v8.453h-2.4v-8.453h-2.7v-1.971h7.8v1.971Z" fill="#6d6e70"/>
    <path id="Path_1374" data-name="Path 1374" d="M606.742,270.748q3.254,0,3.255,2.783a2.416,2.416,0,0,1-.457,1.564,1.737,1.737,0,0,1-1.3.622,2.286,2.286,0,0,1,1.635.686,2.5,2.5,0,0,1,.577,1.754q0,3.015-3.655,3.015H603V270.748Zm.535,4.133a.65.65,0,0,0,.371-.363,2.835,2.835,0,0,0,0-1.543.649.649,0,0,0-.371-.364,2.148,2.148,0,0,0-.778-.108h-1.185v2.485h1.17a2.237,2.237,0,0,0,.793-.107m.236,4.377a.739.739,0,0,0,.442-.4,2.82,2.82,0,0,0,0-1.686.737.737,0,0,0-.45-.4,2.9,2.9,0,0,0-.934-.115h-1.257v2.712h1.257a2.931,2.931,0,0,0,.942-.113" fill="#6d6e70"/>
    <path id="Path_1375" data-name="Path 1375" d="M612.852,279.986a5.877,5.877,0,0,1-1.184-4.014q0-5.367,4.754-5.368a6.636,6.636,0,0,1,2.2.343l-.443,1.913a3.4,3.4,0,0,0-1.614-.357,3.2,3.2,0,0,0-1.535.293,1.625,1.625,0,0,0-.735,1.029,8.131,8.131,0,0,0-.215,2.147,8.223,8.223,0,0,0,.207,2.121,1.568,1.568,0,0,0,.728,1.007,3.205,3.205,0,0,0,1.506.285,3.652,3.652,0,0,0,1.871-.442l.43,1.956a6.473,6.473,0,0,1-2.4.415,4.541,4.541,0,0,1-3.57-1.328" fill="#6d6e70"/>
    <rect id="Rectangle_999" data-name="Rectangle 999" width="1.156" height="10.425" transform="translate(624.556 270.747)" fill="#6d6e70"/>
    <path id="Path_1376" data-name="Path 1376" d="M629.354,270.748l5.34,8.2v-8.2h1.073v10.425h-.914l-5.355-8.2v8.2h-1.072V270.748Z" fill="#6d6e70"/>
    <path id="Path_1377" data-name="Path 1377" d="M637.765,280.757l.229-1.028a6.121,6.121,0,0,0,2.7.6,4.056,4.056,0,0,0,1.343-.171,1.142,1.142,0,0,0,.671-.577,2.753,2.753,0,0,0,.2-1.178,1.791,1.791,0,0,0-.187-.9,1.672,1.672,0,0,0-.643-.571,15.912,15.912,0,0,0-1.6-.728,7.889,7.889,0,0,1-1.466-.737,2.48,2.48,0,0,1-.806-.863,2.623,2.623,0,0,1-.27-1.257q0-2.742,3.026-2.742a6.123,6.123,0,0,1,2.614.544l-.243,1.042a4.339,4.339,0,0,0-2.312-.6,3.712,3.712,0,0,0-1.2.151,1.007,1.007,0,0,0-.593.521,2.5,2.5,0,0,0-.179,1.057,1.819,1.819,0,0,0,.194.915,1.6,1.6,0,0,0,.642.57c.3.161.82.394,1.564.7a8.623,8.623,0,0,1,1.513.743,2.383,2.383,0,0,1,.807.843,2.5,2.5,0,0,1,.265,1.214q0,3.012-3.357,3.013a7.258,7.258,0,0,1-2.913-.558" fill="#6d6e70"/>
    <path id="Path_1378" data-name="Path 1378" d="M646.12,277.573v-6.825h1.129v6.825a5.1,5.1,0,0,0,.206,1.656,1.35,1.35,0,0,0,.714.807,4.659,4.659,0,0,0,2.928,0,1.356,1.356,0,0,0,.714-.807,5.1,5.1,0,0,0,.207-1.656v-6.825h1.1v6.825q0,3.741-3.483,3.74-3.514,0-3.514-3.74" fill="#6d6e70"/>
    <path id="Path_1379" data-name="Path 1379" d="M659.071,270.748q3.141,0,3.143,2.969a2.63,2.63,0,0,1-2.527,2.914l2.9,4.541h-1.33l-2.769-4.469h-1.529v4.469h-1.127V270.748Zm1.223,4.869a1.13,1.13,0,0,0,.634-.629,3.415,3.415,0,0,0,.185-1.271,3.3,3.3,0,0,0-.185-1.249,1.1,1.1,0,0,0-.634-.615,3.616,3.616,0,0,0-1.28-.178H656.93V275.8H659a3.546,3.546,0,0,0,1.293-.185" fill="#6d6e70"/>
    <path id="Path_1380" data-name="Path 1380" d="M665.683,278.644l-.856,2.528h-1.2l3.742-10.423h1.071l3.741,10.423h-1.229l-.842-2.528Zm2.214-6.583-1.9,5.626h3.785Z" fill="#6d6e70"/>
    <path id="Path_1381" data-name="Path 1381" d="M674.952,270.748l5.341,8.2v-8.2h1.071v10.425h-.914l-5.355-8.2v8.2h-1.072V270.748Z" fill="#6d6e70"/>
    <path id="Path_1382" data-name="Path 1382" d="M683.535,275.988a6.307,6.307,0,0,1,1.093-4.041,4,4,0,0,1,3.3-1.344,4.913,4.913,0,0,1,1.986.359l-.229.985a3.834,3.834,0,0,0-1.713-.358,4.24,4.24,0,0,0-2.013.385,2.162,2.162,0,0,0-.994,1.321,9.568,9.568,0,0,0-.292,2.693,9.237,9.237,0,0,0,.292,2.647,2.13,2.13,0,0,0,.986,1.3,4.247,4.247,0,0,0,2.006.379,3.92,3.92,0,0,0,1.944-.441l.213,1.027a5.3,5.3,0,0,1-2.2.413q-4.384,0-4.385-5.325" fill="#6d6e70"/>
    <path id="Path_1383" data-name="Path 1383" d="M698.172,281.172h-6.026V270.747h5.883v.956h-4.754v3.686h4.34v.956h-4.34v3.842h4.9Z" fill="#6d6e70"/>
  </g>
</svg>
</div>

    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import fix_100_vh_android from "@/mixins/fix_100_vh_android";
import fn from "@/helpers/func";
export default {
  props: ["complaint_data"],
  mixins: [resize_handler, fix_100_vh_android],

  data() {
    let validate_phone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
        } else {
          callback();
        }
      }, 1000);
    };

    return {
      success_sent: false,
      recaptcha_verified: false,
      recaptcha_error: false,
      file_list: [],
      file_obj: "",
      focuses: [],
      ruleForm: {
        phone: ""
      },
      rules: {
        phone: [{ validator: validate_phone, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.success_sent = false;
  },
  methods: {
    add_focus(name) {
      let _name = document.querySelector(".el-input__placeholder--name");
      let _email = document.querySelector(".el-input__placeholder--email");
      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _address = document.querySelector(".el-input__placeholder--address");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      let _policy_number = document.querySelector(
        ".el-input__placeholder--policy_number"
      );
      if (!this.focuses.includes(name)) this.focuses.push(name);
      if (name == "name") {
        _name.classList.add("selected");
      } else if (name == "email") {
        _email.classList.add("selected");
      } else if (name == "phone") {
        _phone.classList.add("selected");
      } else if (name == "address") {
        _address.classList.add("selected");
      } else if (name == "textarea") {
        _textarea.classList.add("selected");
      } else if (name == "policy_number") {
        _policy_number.classList.add("selected");
      }
    },
    remove_focus(name, field) {
      this.focuses = this.focuses.filter(foc => foc !== name);
      let _name = document.querySelector(".el-input__placeholder--name");
      let _email = document.querySelector(".el-input__placeholder--email");
      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _address = document.querySelector(".el-input__placeholder--address");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      let _policy_number = document.querySelector(
        ".el-input__placeholder--policy_number"
      );
      if (field.length == 0) {
        if (name == "name") {
          _name.classList.remove("selected");
        } else if (name == "email") {
          _email.classList.remove("selected");
        } else if (name == "phone") {
          _phone.classList.remove("selected");
        } else if (name == "address") {
          _address.classList.remove("selected");
        } else if (name == "textarea") {
          _textarea.classList.remove("selected");
        } else if (name == "policy_number") {
          _policy_number.classList.remove("selected");
        }
      }
    },

    recaptcha_success() {
      this.recaptcha_verified = true;
      this.recaptcha_error = false;
      console.log(this.recaptcha_verified);
    },
    recaptcha_fail() {
      this.recaptcha_verified = false;
      this.recaptcha_error = true;
      console.log(this.recaptcha_error);
    },

    back_to_complaint() {
      this.success_sent = false;

      this.$refs["ruleForm"].resetFields();

      this.close_modal();
    },

    close_modal() {
      document.querySelector(".modal").classList.remove("modal_active");
      
      setTimeout(() => {
        this.$store.state.main.download_modal = !this.$store.state.main
          .download_modal;
      this.$refs["ruleForm"].resetFields();
      this.success_sent = false;
      }, 701);
    },

    async submit_form() {
      let params = {
        phone: this.ruleForm.phone,

      };

      let res = await fn.postData("main/sendsms", params);
      this.success_sent = true;
      console.log(res);
      this.success_sent = true;
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        //&& this.recaptcha_verified
        if (valid ) {
          this.submit_form();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {
    complaint_modal() {
      return this.$store.state.main.download_modal;
    }
  },
  watch: {
    complaint_modal(ns, os) {
      if (ns == true) {
        document
          .querySelector(".header-wrapper.scrolled")
          .classList.add("hide");
          setTimeout(() => {
               document
          .querySelector(".header-wrapper.scrolled")
          .classList.add("hide");
          }, 500);
        setTimeout(() => {
          document
            .querySelector(".download_app_modal")
            .classList.add("modal_active");
        }, 10);
      }
      if (this.windowWidth <= 767) {
        ns == true
          ? document.querySelector("body").classList.add("modal-open")
          : document.querySelector("body").classList.remove("modal-open");
        ns == true
          ? document.querySelector("html").classList.add("modal-open")
          : document.querySelector("html").classList.remove("modal-open");
      }
    },

    focuses(ns, os) {
      console.log(ns);
    },
    $route(to, from) {
      if (this.$store.state.main.download_modal) {
        this.$store.state.main.download_modal = !this.$store.state.main
          .download_modal;
      }
    }
  }
};
</script>

<style lang="sass">
.download_app_modal
  &__see_more
    span
      margin-bottom: 18px
    .j_sb
      @media (max-width: 767px)
        justify-content: initial !important
        flex-direction: column

  .complaint_modal
    &__inner 
      position: relative
      display: flex
      flex-direction: column
    &__success 
      .f-gray 
        margin-top: 44px
      &--button 
        margin-top: 72px
        svg 
          margin-left: 6px
          margin-right: 0
          margin-bottom: 4px
    &__ttl_wrapper
      margin-bottom: 35px
    &__terms
      margin-bottom: 28px
    &_validate_button
      width: 100%
      justify-content: center
      margin-bottom: 26px
      @media (min-width: 1024px)
        &:hover
          background-color: #613DD1 !important
    .el-form-item
      margin-bottom: 28px
  .el-input__inner
    font-size: 16px
  &__footer 
    position: relative
    display: block
    margin-top: auto
    margin-left: auto
    margin-right: auto
    padding-top: 45px
    height: 110px
  @media (max-width: 1206px)
    .complaint_modal__inner 
      padding-bottom: 34px
</style>
